import React, { useState, useEffect, useRef } from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const [currentScriptIndex, setCurrentScriptIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const bharatContainerRef = useRef<HTMLSpanElement>(null);
  
  const bharatScripts = [
    { script: 'भारत', language: 'Hindi' },
    { script: 'Bharat', language: 'English' },
    { script: 'భారత్', language: 'Telugu' },
    { script: 'பாரத்', language: 'Tamil' },
    { script: 'ಭಾರత್', language: 'Kannada' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        setIsAnimating(true);
        
        // Add animating class to trigger CSS transition
        if (bharatContainerRef.current) {
          bharatContainerRef.current.classList.add('animating');
        }
        
        // After animation completes, update the script
        setTimeout(() => {
          setCurrentScriptIndex((prevIndex) => 
            (prevIndex + 1) % bharatScripts.length
          );
          
          // Remove animating class
          if (bharatContainerRef.current) {
            bharatContainerRef.current.classList.remove('animating');
          }
          
          setIsAnimating(false);
        }, 800); // Match CSS transition duration
      }
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, [isAnimating]);

  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      const headerHeight = 80; // Account for fixed header
      const elementPosition = pricingSection.offsetTop - headerHeight;
      
      // Much smoother scrolling with better easing
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Telephony
          </h1>
          <div className="hero-subtitle">
            for <span className="bharat-container" style={{width: '150px'}} ref={bharatContainerRef}>
              <span 
                className="bharat-text current"
                data-language={bharatScripts[currentScriptIndex].language}
              >
                {bharatScripts[currentScriptIndex].script}
              </span>
              {/* <span 
                className="bharat-text next"
                data-language={bharatScripts[(currentScriptIndex + 1) % bharatScripts.length].language}
              >
                {bharatScripts[(currentScriptIndex + 1) % bharatScripts.length].script}
              </span> */}
            </span>
          </div>
          <p className="hero-description">
            Build, deploy, and scale telephony solutions across India with our carrier-agnostic platform.
            Connect agents anywhere, integrate with any AI provider, and stay compliant with Indian regulations.
          </p>
          <button className="hero-cta" onClick={scrollToPricing}>
            Get Started
          </button>
        </div>
        <div className="hero-visual">
          <div className="hero-placeholder">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
              <path d="M20 150 L80 100 L140 120 L180 80" stroke="#e3f2fd" strokeWidth="3" fill="none"/>
              <circle cx="80" cy="100" r="8" fill="#2196f3"/>
              <circle cx="80" cy="100" r="8" fill="#2196f3"/>
              <circle cx="140" cy="120" r="8" fill="#4caf50"/>
              <circle cx="180" cy="80" r="8" fill="#ff9800"/>
              <circle cx="20" cy="150" r="8" fill="#f44336"/>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
